export const css = {
	root: '_2g-N6pWt',
	loading: '_3WvUVJm0',
	buttons: '_1k7Zb_-_',
	oneaction: 'Bx1FPU9s',
	timerblock: 'OW7vIIAH',
	timer: '_2jMBm-hw',
	instruct: '_8ybyXAgB',
	table: '_2BwXxEYD',
	tableHead: '_5I0HJkB_',
	question: 'U137Pafn',
	marked: '_21fKeY72',
	status: '_30vDIEOX',
	complete: 'lPCjelYE',
	incomplete: '_3pqMQMQr',
	row: '_9ZdMQwL4',
	oddRow: '_1ujFJejQ',
	areYouSure: 'lqUfQSS9',
	sureHeading: 'd4ZzxyRR',
	sureBody: '_12sfnG_r',
	sureButtons: 'pMCUXzhA',
	primaryButton: 'zyy5zhJF',
	microReview: '_151j4ER2',
	pill: '_3rAKWAYD',
	' _key': 'quiz-widgets/prometric-review'
};

export default css;
